import React, { useState, useRef, useEffect } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { useChat } from '@vectara/react-chatbot/lib/useChat';
import Icon from '../../molecules/Icon';

import ExploreLinks from './components/ExploreLinks';
import Form from './components/Form';
import Loader from './components/Loader';
import SearchBlock from './components/SearchBlock';

import useAlgolia from '../../hooks/useAlgolia';
import useModal from '../../hooks/useModal';

import { color } from '../../atoms/colors';
import {
  CloseButton,
  Container,
  Content,
  Footer,
  Header,
  Loading,
  MobileCloseButton,
  Modal,
  Text,
  List,
  Wrapper,
} from './styles/index.styled';

const SiteSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [response, setResponse] = useState('');

  const completeResponseRef = useRef('');

  const { closeModal, isOpen } = useModal();

  const { sendMessage, activeMessage, isLoading } = useChat({
    customerId: process.env.GATSBY_VECTARA_CUSTOMER_ID,
    corpusKeys: 'UpKeep',
    apiKey: process.env.GATSBY_VECTARA_API_KEY,
    enableStreaming: true,
    enableFactualConsistencyScore: false,
  });

  const {
    search: algoliaSearch,
    searchResponse: algoliaResponse,
    loading: algoliaLoading,
  } = useAlgolia('upkeep_site_2024');

  useEffect(() => {
    if (activeMessage && activeMessage.answer) {
      const cleanedResponse = activeMessage.answer.replace(/\[\d+\]/g, '');
      completeResponseRef.current = cleanedResponse;
      setResponse(cleanedResponse);
    }
  }, [activeMessage]);

  const uniqueHits = algoliaResponse?.hits.filter(
    (v, i, a) => a.findIndex(t => t.title === v.title) === i
  );

  return (
    <Modal isOpen={isOpen}>
      <Container>
        <Wrapper>
          <CloseButton aria-label="Close Modal" onClick={() => closeModal()}>
            <Icon id="x-close" />
          </CloseButton>
          <Header>
            <Form
              algoliaSearch={algoliaSearch}
              completeResponseRef={completeResponseRef}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              setResponse={setResponse}
              sendMessage={sendMessage}
            />
          </Header>
          <Content renderSearchResults={response}>
            {!response && <ExploreLinks />}
            {isLoading && (
              <Loading>
                <Loader />
              </Loading>
            )}
            <List render={response}>
              <SearchBlock
                heading="UpKeep AI Suggestion"
                icon="stars-02"
                textColor={color.steel[700]}
                response={response}
                loading={isLoading}
              />
              <SearchBlock
                heading="Search Results"
                textColor={color.darkBlue[600]}
                list={uniqueHits}
                loading={algoliaLoading}
              />
            </List>
          </Content>
          <Footer>
            <MobileCloseButton onClick={() => closeModal()}>
              Close
            </MobileCloseButton>
            <Text>
              Powered by
              <Icon
                id="chat-gpt"
                width="24px"
                height="24px"
                fillClor={color.common.white}
              />
            </Text>
          </Footer>
        </Wrapper>
      </Container>
    </Modal>
  );
};

export default SiteSearch;
